import styled, {css} from 'styled-components'

import {Container} from '~/components/general/container/Container'
import {Card} from '~/components/general/card/Card'
import {Button} from '~/components/general/button/Button'
import {Typography} from '~/components/general/typography/Typography'

export const PageContainer = styled(Container)`
  min-height: 100vh;
`

export const PatientHeader = styled(Card)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 16px;
`

export const PatientInfoRow = styled(Container).attrs({
  flex: true,
  direction: 'row',
  align: 'center',
})`
  width: 100%;
  gap: 8px;
`

export const PatientInfoLabel = styled(Typography)`
  flex-shrink: 0;
  min-width: 160px;
`

export const PatientInfoValue = styled(Typography)`
  flex: 1;
`

export const PatientSelectContainer = styled(Container).attrs({
  flex: true,
  direction: 'row',
  align: 'center',
  spacing: 2,
})`
  width: 100%;
`

export const ListCard = styled(Card)`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
`

export const Row = styled(Container).attrs({
  justify: 'space-between',
  align: 'center',
  spacing: 2,
})`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  border-bottom: 1px solid ${({theme}) => theme.colors.grey.grey40};
  &:last-child {
    border-bottom: none;
  }
`

export const RowLeft = styled(Container).attrs({
  align: 'center',
  spacing: 2,
})<{$cancelled?: boolean}>`
  ${({$cancelled}) =>
    $cancelled &&
    css`
      & * {
        text-decoration: line-through;
        opacity: 0.7;
      }
    `}
`

export const HistoryButton = styled(Button)`
  border-radius: ${({theme}) => theme.borderRadius.xs};
  flex: 1;
  min-width: 110px;
  @media (max-width: 420px) {
    font-size: 12px;
    padding: 8px 10px;
    min-width: 88px;
  }
`

export const ActionButton = styled(Button)`
  border-radius: ${({theme}) => theme.borderRadius.xs};
  flex: 1;
  min-width: 110px;
  background-color: ${({theme}) => theme.colors.secondary.orange200};
  &:hover {
    background-color: ${({theme}) => theme.colors.secondary.orange600};
  }
  @media (max-width: 420px) {
    font-size: 12px;
    padding: 8px 10px;
    min-width: 88px;
  }
`

export const ActionsContainer = styled(Container).attrs({
  align: 'center',
  spacing: 2,
  flex: true,
})`
  flex-wrap: wrap;
  gap: 8px;
`

export const EmptyState = styled(Container)`
  padding: 12px 0;
`

export const HistoryList = styled(Container).attrs({
  direction: 'column',
  spacing: 1,
})`
  padding-left: 12px;
  border-left: 2px solid ${({theme}) => theme.colors.grey.grey20};
`

export const HistoryItem = styled(Container).attrs({
  direction: 'column',
  spacing: 1,
})`
  padding: 8px 0;
  border-bottom: 1px solid ${({theme}) => theme.colors.grey.grey40};
  &:last-child {
    border-bottom: none;
  }
`
